import { render } from "./Calendar.vue?vue&type=template&id=53777c2a&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=ts"
export * from "./Calendar.vue?vue&type=script&lang=ts"

import "./Calendar.vue?vue&type=style&index=0&id=53777c2a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-53777c2a"

export default script